import {
  SharedFileRequestContextType,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import {
  StepItem,
  StepsProps
} from "../../../../../../shared/components/Steps";
import { selectorIsSharedFileNotNoneContext } from "../../../../selectors/selectorIsSharedFileNotNoneContext";

/**
 * Steps for a smart (non-`None` context) request — the ones that run
 * extraction/validation jobs after the upload.
 */
const getStepsForSmartContext = (
  status: SharedFileRequestStatus
): StepItem[] => {
  const allStepsCombinations: Record<
    SharedFileRequestStatus,
    StepsProps["steps"]
  > = {
    [SharedFileRequestStatus.COMPLETE]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Complete"
      },
      {
        title: "Acceptance",
        status: "Complete"
      }
    ],
    [SharedFileRequestStatus.PROCESSING]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Active"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ],
    [SharedFileRequestStatus.PENDING_UPLOAD]: [
      {
        title: "Upload",
        status: "Active"
      },
      {
        title: "Validation",
        status: "Pending"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ],
    [SharedFileRequestStatus.PENDING_SUBMISSION]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Warning"
      },
      {
        title: "Acceptance",
        status: "Active"
      }
    ],
    [SharedFileRequestStatus.FAILED]: [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Validation",
        status: "Failed"
      },
      {
        title: "Acceptance",
        status: "Pending"
      }
    ]
  };

  return allStepsCombinations[status];
};

const getStepsForGeneralContext = (
  status: SharedFileRequestStatus
): StepItem[] => {
  if (status === SharedFileRequestStatus.PENDING_UPLOAD) {
    return [
      {
        title: "Upload",
        status: "Active"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ];
  } else if (status === SharedFileRequestStatus.COMPLETE) {
    return [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ];
  } else {
    return [
      {
        title: "Upload",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ];
  }
};

export const getSharedFileProgressSteps = (
  status: SharedFileRequestStatus,
  contextType: SharedFileRequestContextType | undefined
): StepItem[] => {
  let steps: StepItem[];

  if (selectorIsSharedFileNotNoneContext(contextType)) {
    steps = getStepsForSmartContext(status);
  } else {
    steps = getStepsForGeneralContext(status);
  }

  return steps;
};
